const yup = require("yup");

const IJMB = yup.object({
  institutionName: yup.string().required("Institution name is a required field"),
  yearOfGraduation: yup.string().required("Year of graduation is  a required field"),
  educationSubject: yup.string().required("Education subject is a required field"),
  educationSubjectGrade: yup.string().required("Education subject grade is a required field"),
  educationSubject2: yup.string().required("Education subject 2 is a required field"),
  educationSubject2Grade: yup.string().required("Education subject 2 grade is a required field"),
  educationSubject3: yup.string().required("Education subject 3 is a required field"),
  educationSubject3Grade: yup.string().required("Education subject 3 grade is a required field"),
});

const Diploma = yup.object({
  institutionName: yup.string().required("Institution name is a required field"),
  yearOfGraduation: yup.string().required("Year of graduation is  a required field"),
  courseOfStudy: yup.string().required("Course of study is a required field"),
  classification: yup.string().required("Classification of grade is a required field"),
  diplomaType: yup.string().required("Type of diploma is a required field"),
  cgpa: yup.string().required("CGPA is a required field"),
});

const NCE = yup.object({
  institutionName: yup.string().required("Institution name is a required field"),
  yearOfGraduation: yup.string().required("Year of graduation is  a required field"),
  educationSubject: yup.string().required("Education subject is a required field"),
  educationSubjectGrade: yup.string().required("Education subject grade is a required field"),
  educationSubject2: yup.string().required("Education subject 2 is a required field"),
  educationSubject2Grade: yup.string().required("Education subject 2 grade is a required field"),
  educationSubject3: yup.string().required("Education subject 3 is a required field"),
  educationSubject3Grade: yup.string().required("Education subject 3 grade is a required field"),
});

const result = yup.object({
  type: yup.string().required("Result type is required"),
  results: yup.object().required("Result information is required"),
});

module.exports = {
  IJMB,
  NCE,
  Diploma,
  result,
};
